import { inject, Injectable } from '@angular/core';
import { environment } from "@wms/app";
import { WmHttpService } from '../http/wm-http.service';
import { ProjectService } from '../project/project.service';

@Injectable({
  providedIn: 'root'
})
export class MyWidgetsServiceService {
  private TARGET: string = "MyWidgets";
  private API_META: any = {
    getWidgetList: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/resources/info/web/custom-widgets",
      method: "GET"
    },
    getConfig: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/resources/info/web/custom-widgets/:widgetName/config.json",
      method: "GET"
    },
    getResources: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/resources/info/web/custom-widgets/:widgetName/page.min.json",
      method: "GET"
    },
  }
  private projectService: ProjectService;
  
  constructor(private wmHttpService: WmHttpService) {
    this.wmHttpService.registerApiMeta(this.TARGET, this.API_META);
    this.projectService = inject(ProjectService);
  }

  
  getConfig(params: any) {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "getConfig",
      urlParams: {
        projectID: this.projectService.getProjectId(),
        widgetName: params.widgetName
      }
    }) as Promise<any>);
  }

  getResources(params: any) {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "getResources",
      urlParams: {
        projectID: this.projectService.getProjectId(),
        widgetName: params.widgetName
      }
    }) as Promise<any>);
  }
}
